import { LanePollDataAction, CommonAction } from 'Actions/index';
import { LanePollDataActionTypes, CommonActionTypes } from 'Actions/ActionTypes/index';
import { ILanePollData } from 'Store/Tss/ILanePollData';
import Util from 'Util/index';

const initialState: ILanePollData = {};

/**
 * Defines a function to calculate a new state for Lane Poll Data
 * based on the given action.  The state must not be directly mutated and
 * the function should always return a new copy of the state.  If nested objects
 * are present be sure to perform a deep copy.
 * @param {} state - the previous state
 * @param {} action  - the action to be performed to calculate the new state
 * @returns {} - a new state object
 */
export const lanePollData = (state: ILanePollData = initialState, action: LanePollDataAction | CommonAction): ILanePollData => {

    let newState: ILanePollData;

    switch (action.type) {
        case LanePollDataActionTypes.AddLanePollData:
        case LanePollDataActionTypes.ModifyLanePollData:
            newState = { ...state };
            action.lanePollData.forEach(pollData => {
                newState[Util.IdToString(pollData.id!)] = pollData;
            });
            break;
        case LanePollDataActionTypes.DeleteLanePollData:
            newState = { ...state };
            action.ids.forEach(id => delete newState[Util.IdToString(id!)]);
            break;
        case CommonActionTypes.ClearStore:
            newState = initialState;
            break;
        default:
            newState = state;
    }

    return newState;

}